import styled from "styled-components";
export const SideMenuContainer = styled.div`
    background: var(--background-secondary-color);
    transition: all ease-in-out .3s;
    transform: ${({ $isShowSideBar }) => !$isShowSideBar?`translate(calc(var(--sidebar-width) * -1), 0px)`:`translate(0px, 0px)`};
    
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 100%;
        transform: translate(0, 0);
        position: absolute;
        height: 100%;
        left: ${({ $isShowSideBar }) => !$isShowSideBar?`-100%`:`0`};
        bottom: 0;
        top: 60px;
        z-index: 999999;
    }
`
export const SideMenuWrapper = styled.div`
    padding: 1em;
    a {
        display: block;
        text-transform: uppercase;
        padding: .8em 1em;
        font-weight: 600;
        text-decoration: none;
        color: var(--text-color);
        background: var(--header-background-color);
        margin: .5em 0;
        border-radius: 10px;
        transition: all ease-in-out .3s;
        & svg{
            margin-right: .5em;
        }
        &:hover, &.active-menu{
            transition: all ease-in-out .3s;
            background: var(--primary-color);
        }
    }
    
    
`